module.exports = __webpack_public_path__ + "static/media/user-5.959b0148.png";